export const setFocus = (element: HTMLElement | null | undefined): void => {
	element?.focus();
};

export const returnFocusToBody = (): void => {
	setFocus(document.body);
};
